import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyACGfGTsMa7TTH46iJTlWfpcJke0PBr97M",
    authDomain: "liquidatorrp.firebaseapp.com",
    projectId: "liquidatorrp",
    storageBucket: "liquidatorrp.appspot.com",
    messagingSenderId: "943818381926",
    appId: "1:943818381926:web:c6aae16bb2c4fedf6b2ba7"
};

export const fb = firebase.initializeApp(firebaseConfig);
export const admin = firebase.firestore.FieldValue;